import { HiddenIcon, styled } from 'canoe';
import React from 'react';

const ControlVariantContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 205px;
  height: 130px;
`;

export const ControlGroupDocument = () => (
  <ControlVariantContent>
    <HiddenIcon />
  </ControlVariantContent>
);
